module.exports = __webpack_public_path__ + "img/حمضيات.60cf17bb.png";